// React
import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

// 3rd party libs
import FloatingLabelInput from "react-floating-label-input";
import toast from "react-hot-toast";
import cookie from "react-cookies";
import { db } from "../../../../Firebase/firebase";

// Utilities
import { match } from "../../../../Others/functions";
import { handleInput } from "../../../../Others/eventHandlers";
import { userSignUp } from "../../../../Request/UserRequests";
import {
  fetchCart,
  saveAddress,
  saveUser,
  setCurrentLocation,
} from "../../../../Redux/Actions/userActions";
import { fetchLocation } from "../../../../Request/LoginRequests";
import { ClipLoader } from "react-spinners";
import Input from "../../../../Others/Input";

export default function SignUp({ phn, update }) {
  const [valid, setValid] = useState(false);
  const { store } = useParams();
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.user.cart);
  const info = useSelector(
    (state) =>
      state.vendor.vendorList?.filter((el) =>
        match(el.info?.storeLink, store)
      )?.[0]?.info
  );
  const delivery = useSelector(
    (state) =>
      state.vendor.vendorList?.filter((el) =>
        match(el.info?.storeLink, store)
      )?.[0]?.deliveryArea
  );

  const [name, setName] = useState("");
  const [pin, setPin] = useState("");
  const [address, setAddress] = useState("");
  const [area, setArea] = useState("");
  const [pinList, setPinList] = useState([]);
  const [areaList, setAreaList] = useState([]);
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [load, setLoad] = useState(false);
  const [phone, setPhone] = useState();

  useEffect(() => {
    if (!delivery?.filter((el) => el.pincode)?.length && pin?.length === 6) {
      setLoad(true);
      fetchLocation(pin)
        .then((res) => {
          setAreaList(res.map((el) => ({ area: el.placeName })));
          setArea(res[0].placeName);
          setCity(res[0].adminName3);
          setState(res[0].adminName1);
        })
        .catch(() => toast.error("Invalid Pincode", { id: "err" }))
        .finally(() => setLoad(false));
    } else if (pin?.length !== 6) {
      setCity("");
      setState("");
      setArea("");
      setAreaList([]);
    }
  }, [pin, delivery]);

  useEffect(() => {
    if (!delivery?.filter((el) => el.pincode).length) {
      setPin(info?.pincode);
      setCity(info?.city);
      setState(info?.state);
    } else {
      const x = localStorage.getItem('phn');
      if (phn.length!==0)
      {
        setPhone(phn)
      } else {
        setPhone(x);
        }
      
      setCity(delivery[0].city);
      setState(delivery[0].state);
      let pins = [...new Set(delivery.map((el) => el.pincode))];
      setPinList(pins);
      setPin(pins[0]);
      setArea(delivery[0].area);
      setAreaList(delivery.map((el) => ({ area: el.area })));
    }
  }, [delivery, info, phn]);
  // delivery, info?.city, info?.pincode, info?.state
  useEffect(() => {
    if (
      !(
        name?.length &&
        /^[1-7]{1}[0-9]{5}$/.test(pin) &&
        address?.length &&
        area?.length &&
        city?.length &&
        state?.length
      )
    )
      setValid(false);
    else setValid(true);
  }, [name, pin, address, area, city, state]);

  function handleSignUp() {
    userSignUp({
      name,
      phn:phone,
      address,
      area,
      city,
      state,
      pin,
    })
      .then((res) => {
        toast.success("Signed Up");
        cookie.save("uid", res.userHash, {
          path: "/",
          expires: new Date(new Date().setDate(new Date().getDate() + 360)),
        });
        dispatch(saveUser({ name, phn, userHash: res.userHash }));
        let cur = {
          name,
          address,
          area,
          city,
          state,
          pincode: pin,
          primary: "true",
          addressId: res.addressId,
        };
        dispatch(saveAddress([{ ...cur }]));
        dispatch(setCurrentLocation(cur));
        let tempCart = cart;
        localStorage.removeItem("cart");
        dispatch(fetchCart(tempCart));
        db.collection("Users").doc(res.userHash).set({ cart: tempCart });
        document.getElementById("closeSignUp").click();
      })
      .catch((err) => console.log(err));
  }

  return (
    <div
      className="offcanvas offcanvas-bottom bg-tr h-auto"
      tabIndex="-1"
      id="cartSignUp"
    >
      <div
        className="bi bi-x-circle fs-lg mx-auto text-white"
        id="closeSignUp"
        data-bs-dismiss="offcanvas"
      ></div>
      <div className="p-4 round-top text-light bg-orange fw-bold fs-3 py-2">
        <span className="bi bi-card-checklist me-2 fs-1"></span>
        Sign Up
      </div>

      {/* Sign up Form */}
      <div className="p-4 pb-2 bg-white">
        {/* Name */}
        <FloatingLabelInput
          id="name"
          label="Full Name"
          className="fs-3 floating-label animate-2"
          placeholder="Enter Full Name"
          value={name}
          onChange={(e) => handleInput(e, setName)}
        />
        <br />

        {/* Phn No */}
        <FloatingLabelInput
          id="phn"
          label="Mobile No."
          className="floating-label animate-2 fs-3 animate-2"
          readOnly
          value={phone}
        />

        <br />
        <FloatingLabelInput
          id="name"
          label="Address"
          className="fs-3 floating-label animate-2"
          placeholder="Enter your address"
          value={address}
          onChange={(e) => handleInput(e, setAddress)}
        />
        <br />

        {/* Case: No delivery areas */}
        <div className="d-flex">
          {!delivery?.filter((el) => el.pincode).length ? (
            <div className="w-100" style={{ position: "relative" }}>
              <label
                style={{
                  position: "absolute",
                  transform: "translate(0,-75%)",
                  color: "#9b9b9b",
                }}
              >
                Pincode
              </label>
              <Input
                value={pin}
                dotPrecision={0}
                isAllowed={({ value }) =>
                  value === "" || (value > 0 && value < Math.pow(10, 6))
                }
                name="pin"
                placeholder="eg. 110001"
                style={{ pb: 0.1, mt: 0.35 }}
                fontsize="calc(1.3rem + .6vw)"
                onChange={(e) => setPin(e.target.value)}
              />
              <div
                style={{
                  position: "absolute",
                  right: "2px",
                  bottom: "50%",
                  transform: "translate(0%,75%)",
                }}
              >
                <ClipLoader size="15px" color="#e96125" loading={load} />
              </div>
            </div>
          ) : (
            <div className="w-100" style={{ position: "relative" }}>
              <label
                style={{
                  position: "absolute",
                  transform: "translate(0,-75%)",
                  color: "#9b9b9b",
                }}
              >
                Pincode
              </label>
              <select
                className="form-select fs-3 p-0 rounded-0"
                onChange={(e) => {
                  setPin(e.target.value);
                  let location = delivery?.filter(
                    (el) => el.pincode === e.target.value
                  );
                  setAreaList(location);
                  setCity(location[0].city);
                  setState(location[0].state);
                }}
              >
                {pinList.map((el, i) => (
                  <option key={i} value={el}>
                    {el}
                  </option>
                ))}
              </select>
            </div>
          )}
          <div className="mx-2"></div>
          <div className="w-100" style={{ position: "relative" }}>
            <label
              style={{
                position: "absolute",
                transform: "translate(0, -75%)",
                color: "#9b9b9b",
              }}
            >
              Area
            </label>
            <select
              className="form-select fs-3 p-0 pe-4 rounded-0"
              onChange={(e) => setArea(e.target.value)}
              style={{
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
                top: 'auto', bottom: '100%'
              }}
            >
              {areaList.map((op, i) => (
                <option
                  key={i}
                  value={op.area}
                  style={{
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                  }}
                >
                  {op.area}
                </option>
              ))}
            </select>
          </div>
        </div>

        <br />
        <div className="d-flex">
          <div className="w-100">
            <FloatingLabelInput
              id="city"
              label="City"
              className="floating-label animate-2 fs-3 animate-2 w-100"
              placeholder="(auto-filled)"
              value={city}
              onChange={(e) => handleInput(e, setCity)}
              readOnly
            />
          </div>
          <div className="mx-2"></div>
          <div className="w-100">
            <FloatingLabelInput
              id="state"
              label="State"
              className="floating-label animate-2 fs-3 animate-2 w-100"
              placeholder="(auto-filled)"
              value={state}
              onChange={(e) => handleInput(e, setState)}
              readOnly
            />
          </div>
        </div>
      </div>
      <div className="py-2 bg-white px-4 d-flex">
        <button
          className="btn-cnf btn-danger fs-3 py-1 w-100"
          onClick={() => {
            document.getElementById("cartLoginSpan").click();
            update("cartLoginSpan");
          }}
        >
          Back
        </button>
        <div className="mx-2"></div>
        <button
          className="btn-cnf btn-orange fs-3 py-1 w-100 animate-2"
          disabled={!valid}
          onClick={handleSignUp}
        >
          Sign up
        </button>
      </div>
    </div>
  );
}
